/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Resource_Integrate_TitleInputs */

const en_blog_resource_integrate_title = /** @type {(inputs: Blog_Resource_Integrate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review integration options`)
};

const zh_blog_resource_integrate_title = /** @type {(inputs: Blog_Resource_Integrate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看集成选项`)
};

/**
* | output |
* | --- |
* | "Review integration options" |
*
* @param {Blog_Resource_Integrate_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_resource_integrate_title = /** @type {((inputs?: Blog_Resource_Integrate_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Resource_Integrate_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_resource_integrate_title(inputs)
	return zh_blog_resource_integrate_title(inputs)
});
export { blog_resource_integrate_title as "blog.resource_integrate_title" }